import { render } from "./index.vue?vue&type=template&id=1225f57a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elsengel/Documents/pointer/knd/projects/2022/gevecht-grond/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__